// file: packageDetails.jsx
import React from "react";
import styles from "./packageDetails.module.scss";
import CustomButton from "../../customComponents/customButton/CustomButton";
import DoneIcon from "@mui/icons-material/Done";
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";

const PackageDetails = ({ handleSaveChange, handleChange, packageData }) => {
  const setPackageData = (key, value) => {
    handleChange(key, value);
  };

  const isDisable =
    packageData?.type &&
    packageData?.length &&
    packageData?.breadth &&
    packageData?.weight;
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h3 className={styles.title}>Box Details</h3>
          {/* <div className={styles.tabs}>
            <button className={`${styles.tab} ${styles.active}`}>1</button>
            <button className={styles.tab}>2</button>
            <button className={styles.addBox}>+ Add Box</button>
          </div> */}
        </div>
        <div className={styles.boxSection}>
          {/* <h4 className={styles.boxTitle}>BOX 1</h4> */}

          <div className={styles.formGroup}>
            <FormControl
              fullWidth
              margin="normal"
              classes={{ root: styles.inputContainer }}
            >
              <InputLabel id="packageType-label">Package Type</InputLabel>
              <Select
                labelId="status-label"
                value={packageData["type"]}
                label="Package Type"
                onChange={(event) => setPackageData("type", event.target.value)}
                className={styles.input}
              >
                <MenuItem value="0">Plastic cover/Flyer</MenuItem>
                <MenuItem value="1">Cardboard Box</MenuItem>
              </Select>
            </FormControl>
            {/* <label className={styles.label}>Package Type</label>
            <select className={styles.select}>
              <option>Select Package Type</option>
            </select>
            <span className={styles.helperText}>
              Select package which will be used to ship
            </span> */}
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Size</label>
            <div className={styles.sizeInputs}>
              <FormControl
                variant="outlined"
                classes={{ root: styles.inputContainer }}
                fullWidth
              >
                <InputLabel id={`label-date`}>Length</InputLabel>

                <OutlinedInput
                  id="outline-input-date"
                  type="text"
                  classes={{
                    root: styles.input,
                    input: styles.inputField,
                  }}
                  label="Length"
                  value={packageData["length"]} // ✅ Ensures empty on load
                  onChange={(event) =>
                    setPackageData("length", event.target.value)
                  }
                />
              </FormControl>
              <FormControl
                variant="outlined"
                classes={{ root: styles.inputContainer }}
                fullWidth
              >
                <InputLabel id={`label-date`}>Breadth</InputLabel>

                <OutlinedInput
                  id="outline-input-date"
                  type="text"
                  classes={{
                    root: styles.input,
                    input: styles.inputField,
                  }}
                  label="Breadth"
                  value={packageData["breadth"]} // ✅ Ensures empty on load
                  onChange={(event) =>
                    setPackageData("breadth", event.target.value)
                  }
                />
              </FormControl>
              <FormControl
                variant="outlined"
                classes={{ root: styles.inputContainer }}
                fullWidth
              >
                <InputLabel id={`label-date`}>Height</InputLabel>

                <OutlinedInput
                  id="outline-input-date"
                  type="text"
                  classes={{
                    root: styles.input,
                    input: styles.inputField,
                  }}
                  label="Height"
                  value={packageData["height"]} // ✅ Ensures empty on load
                  onChange={(event) =>
                    setPackageData("height", event.target.value)
                  }
                />
              </FormControl>

              {/* <input type="text" placeholder="e.g 1" className={styles.input} />
              <input type="text" placeholder="e.g 1" className={styles.input} />
              <input type="text" placeholder="e.g 1" className={styles.input} /> */}
              <span className={styles.unit}>cm</span>
            </div>
            <span className={styles.helperText}>
              Length + Breadth + Height should be at-least 15 cm
            </span>
          </div>

          <div className={styles.formGroup}>
            {/* <label className={styles.label}>Package weight</label> */}
            <div className={styles.weightInput}>
              <FormControl
                variant="outlined"
                classes={{ root: styles.inputContainer }}
                fullWidth
              >
                <InputLabel id={`label-date`}>Package weight</InputLabel>

                <OutlinedInput
                  id="outline-input-date"
                  type="text"
                  classes={{
                    root: styles.input,
                    input: styles.inputField,
                  }}
                  label="Package weight"
                  value={packageData["weight"]} // ✅ Ensures empty on load
                  onChange={(event) =>
                    setPackageData("weight", event.target.value)
                  }
                />
              </FormControl>

              {/* <input
                type="text"
                placeholder="Enter package weight"
                className={styles.input}
              /> */}
              <span className={styles.unit}>gm</span>
            </div>
            <span className={styles.helperText}>
              Packaged weight should be at least 50 grams
            </span>
          </div>

          {/* <div className={styles.noteBox}>
            <p className={styles.noteText}>
              The estimated cost may vary from the final shipping cost based on
              the packaged dimensions & weight measured before delivery.
            </p>
          </div> */}

          {/* <div className={styles.summary}>
                <p className={styles.chargeLabel}>Total Chargeable Weight</p>
                <p className={styles.chargeValue}>-- gm</p>
            </div> */}

          {/* <div className={styles.shippingMode}>
            <p className={styles.modeTitle}>Choose shipping mode</p>
            <div className={styles.modeButtons}>
              <button className={`${styles.modeBtn} ${styles.active}`}>
                🚚 SURFACE <br /> ₹ --
              </button>
              <button className={styles.modeBtn}>
                ⚡ EXPRESS <br /> ₹ --
              </button>
            </div>
          </div> */}

          {/* <div className={styles.costBreakup}>
            <div className={styles.breakupHeader}>
              <span>Shipping Cost Breakup</span>
              <span>⌄</span>
            </div>
            <div className={styles.breakupList}>
              <div className={styles.breakupItem}>
                <span>Freight Cost</span>
                <span>--</span>
              </div>
              <div className={styles.breakupItem}>
                <span>Fuel Surcharge</span>
                <span>--</span>
              </div>
              <div className={styles.breakupItem}>
                <span>GST - 18% (CGST+SGST)</span>
                <span>--</span>
              </div>
              <div className={styles.breakupItemTotal}>
                <span>Total</span>
                <span>--</span>
              </div>
            </div>
          </div> */}
          <CustomButton
            title={"Save Changes"}
            txtClr={"#FFFFFF"}
            background={!isDisable ? "grey" : "hsla(187, 98%, 16%, 1)"}
            width={"100%"}
            height={"34px"}
            borderRadius={"12px"}
            disabled={!isDisable}
            onClick={() => handleSaveChange()}
          />
        </div>
      </div>
    </div>
  );
};

export default PackageDetails;
